import { Box, Button, Card, Grid, Typography } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import useAccount from '../../hooks/useAccount';
import useNature from '../../hooks/useNature';
import { FormField } from "../dynamicSubscription/index";
import { useSelector } from 'react-redux';
import useSubscription from '../../hooks/useSubscription';
import useCompanies from '../../hooks/useCompanies';
import { convertToLocal } from '../../config/functions';
import Table from '../../components/Table';
export default function Default() {
    const {
        getAllUsers,
        addAccount,
        addAttachment,
        getCrmAttachments,
        comments,
        users,
        data, setData,
        selectedUser, setSelectedUser,
        commentData, setCommentData,
        loading,
        updateAccount,
        downloadFilesAsZip,
        getPaymentPaidToAdmin,
        subscriptionPayments,
        fetchPaymentsByEmail,
        fetchSubscriptionPayments,
        invoicePayments,
        adminPayments
    } = useAccount()
    const { fetchBranches, branches, managers, fetchEmployees } = useCompanies()
    const { getData: getSubscriptionData } = useSubscription()
    const { subscriptions } = useSelector((state) => state.subscription);
    const location = useLocation()
    let editData = location.state
    const [query] = useSearchParams()
    const edit = query.get('edit')
    const {
        fetchNatures,
        natures
    } = useNature();

    useEffect(() => {
        getSubscriptionData()
        if (editData) {
            setData({
                ...editData,
                linkedAccount: editData?.linkedAccount?._id,
                parentAccount: editData?.parentAccount?._id,
                nature: editData?.linkedAccount?.nature?._id ? editData.linkedAccount?.nature?._id : editData.nature?._id,
                email: editData.email ? editData.email : editData.linkedAccount?.email,
                subscriptionID: editData?.linkedAccount?.subscriptionID?._id
            })
            fetchSubscriptionPayments(
                editData.linkedAccount?.stripeCustomerId,
            )
            fetchPaymentsByEmail(
                editData.email ? editData.email : editData.linkedAccount?.email
            )
            if (editData?.linkedAccount?.role == 'companyAdmin') {
                getPaymentPaidToAdmin(
                    editData.linkedAccount?.stripeConnectID
                )
            }
            setSelectedUser(editData.linkedAccount)
            getCrmAttachments(editData._id)
        }
        getAllUsers()
        fetchNatures()
    }, [editData])
    useEffect(() => {
        if (data.linkedAccount) {
            fetchBranches(data?.linkedAccount || editData?.linkedAccount?._id)
            fetchEmployees(data?.linkedAccount || editData?.linkedAccount?._id)
        }
    }, [data.linkedAccount])

    let fields = [
        {
            value: data?.name,
            setValue: (value) => setData({ ...data, name: value }),
            label: "Enter account name",
            placeholder: "Enter account name",
            type: "text",
            id: "name",
            required: true,
        },
        {
            value: data?.parentAccount,
            setValue: (value) => {
                setData({ ...data, parentAccount: value })
            },
            label: "Select parent account",
            placeholder: "Select parent account",
            options: users,
            type: "dropdown",
            id: "parentAccount",
        },
        {
            value: data?.linkedAccount,
            setValue: (value) => {
                setData({ ...data, linkedAccount: value })
                let selectedAccount = users.filter(item => item._id == value)
                setSelectedUser(selectedAccount[0])
                setData(prevState => {
                    let newState = { ...prevState }
                    newState.linkedAccount = value
                    newState.address = selectedAccount[0]?.address ? selectedAccount[0].address : ''
                    newState.phone = selectedAccount[0]?.phone ? selectedAccount[0].phone : ''
                    newState.website = selectedAccount[0]?.website ? selectedAccount[0].website : ''
                    newState.email = selectedAccount[0]?.email ? selectedAccount[0].email : ''
                    newState.nature = selectedAccount[0]?.nature ? selectedAccount[0].nature._id : ''
                    newState.employees = selectedAccount[0]?.employees ? selectedAccount[0].employees : ''
                    return newState
                })
            },
            label: "Select linked account",
            placeholder: "Select linked account",
            // disabled: edit ? true : false,
            options: users,
            type: "dropdown",
            id: "linkedAccount",
        },
        {
            value: data?.address,
            setValue: (value) => setData({ ...data, address: value }),
            label: "Enter address",
            placeholder: "Enter address",
            disabled: !edit && selectedUser?.role == 'company',
            type: "text",
            id: "address",
            required: true,
        },
        {
            value: data?.phone,
            setValue: (value) => setData({ ...data, phone: value }),
            label: "Enter phone",
            placeholder: "Enter phone",
            disabled: !edit && selectedUser?.role == 'company',
            type: "text",
            id: "phone",
            required: true,
        },
        {
            value: data?.website,
            setValue: (value) => setData({ ...data, website: value }),
            label: "Enter website",
            placeholder: "Enter website",
            disabled: !edit && selectedUser?.role == 'company',
            type: "text",
            id: "website",
            required: true,
        },
        {
            value: data?.nature,
            setValue: (value) => setData({ ...data, nature: value }),
            label: "Select industry",
            placeholder: "Select industry",
            required: true,
            // disabled: edit ? true : false,
            options: natures,
            type: "dropdown",
            id: "nature",
        },
        ...(selectedUser?.role == 'company' ? [
            {
                label: "Select Subscription",
                value: data?.subscriptionID,
                setValue: (value) =>
                    setData({ ...data, subscriptionID: value }),
                placeholder: 'Select Subscription',
                type: "dropdown",
                id: "subscriptionID",
                options: subscriptions,
                required: true,
            }
        ] : []),
        {
            value: data?.email,
            setValue: (value) => setData({ ...data, email: value }),
            label: "Enter email",
            placeholder: "Enter email",
            type: "email",
            disabled: data.linkedAccount,
            id: "email",
            required: true,
        },
        {
            value: data?.employees,
            setValue: (value) => setData({ ...data, employees: value }),
            label: "Enter employees",
            placeholder: "Enter employees",
            disabled: !edit && selectedUser?.role == 'company',
            type: "number",
            id: "employees",
            required: true,
        },
    ].filter(it => it);
    const adminLabels = [
        "#",
        "Amount",
        "Amount Reversed",
        "Currency",
        "Status",
        "Created at",
    ].filter((item) => item);
    const labels = [
        "#",
        "Amount Paid",
        "Amount Recieved",
        "Fee Deducted",
        "Currency",
        "Type",
        "Status",
        "Created at",
    ].filter((item) => item);
    const subscriptionPaymentData = useMemo(() => {
        return subscriptionPayments?.map((item, index) => {
            return {
                data: item,
                fields: [
                    index + 1,
                    <p>{item?.amount / 100}</p>,
                    <p>{item?.amount_received ? item.amount_received / 100 : item.amount_captured / 100}</p>,
                    <p>{item?.application_fee_amount / 100 || 0}</p>,
                    <p>{item?.currency}</p>,
                    'Subscription',
                    <p>{item?.status}</p>,
                    convertToLocal(item?.created),
                ].filter((it) => it),
            };
        });
    }, [subscriptionPayments, loading]);
    const adminPaymentData = useMemo(() => {
        return adminPayments?.map((item, index) => {
            return {
                data: item,
                fields: [
                    index + 1,
                    <p>{item?.amount / 100}</p>,
                    <p>{item.amount_reversed / 100}</p>,
                    <p>{item?.currency}</p>,
                    <p>{item?.reversed ? 'Reversed' : "Transfered"}</p>,
                    convertToLocal(item?.created),
                ].filter((it) => it),
            };
        });
    }, [adminPayments, loading]);
    const invoicePaymentData = useMemo(() => {
        return invoicePayments?.map((item, index) => {
            return {
                data: item,
                fields: [
                    index + 1,
                    <p>{item.subscriptionID?.cost}</p>,
                    <p>{item.subscriptionID?.status != 'pending' ? item.subscriptionID?.cost : 0}</p>,
                    <p>{0}</p>,
                    <p>gbp</p>,
                    'Invoice',
                    <p>{item.subscriptionID?.status}</p>,
                    convertToLocal(item?.createdAt),
                ].filter((it) => it),
            };
        });
    }, [invoicePayments, loading]);

    return (
        <Screen
            loading={loading == 'initial'}
            flow={[
                { label: `${editData ? 'Update' : 'Add'} Account`, to: `/add-crm-account` },
                { label: "Home", to: "/" },
                { label: `${editData ? 'Update' : 'Add'} Account`, to: `/add-crm-account` },
            ]}>
            <div className="row gap-3 card py-4">
                <div className="card-body">
                    {fields.map((item) => (
                        <div className="col-12">
                            <FormField field={item} />
                        </div>
                    ))}
                </div>
                {branches?.length > 0 && <>
                    <center>
                        <Typography variant='h4'>Sites</Typography>
                        <hr />
                    </center>
                    <Grid container columnSpacing={1}>
                        {
                            branches.map((item, index) => (
                                <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                    <Card sx={{
                                        padding: '20px 30px'
                                    }}>
                                        <Typography><b>Site Name:</b> {item.name}</Typography>
                                        <Typography><b>Manager Name:</b> {managers?.find((m) => m._id == item.managerID)?.name}</Typography>
                                        <Typography><b>Manager Email:</b> {managers?.find((m) => m._id == item.managerID)?.email}</Typography>
                                    </Card>
                                </Grid>
                            ))
                        }
                    </Grid>
                </>}
                <div className="d-flex justify-content-center mt-4">
                    <SubmitButton
                        title={edit ? "Update" : "Add account"}
                        loading={loading == "new" || loading == "update"}
                        onClick={() => {
                            if (editData?._id) {
                                updateAccount()
                            } else {
                                addAccount()

                                // onAddSubscription();
                            }
                        }}
                        color={"success"}
                        loaderColor={"white"}
                        disabled={
                            data.name == ""
                        }
                    />
                </div>
                <hr style={{ marginTop: '10px' }} />
                {editData && <>
                    {editData.linkedAccount && <>
                        <Table
                            labels={labels}
                            data={subscriptionPaymentData}
                            title='Subscription Payments'
                        />
                    </>}
                    {(editData.email || editData.linkedAccount) && <>
                        <Table
                            labels={labels}
                            data={invoicePaymentData}
                            title="Invoice Payments"
                        />
                    </>}
                    {(editData?.linkedAccount?.role == 'companyAdmin') && <>
                        <Table
                            labels={adminLabels}
                            data={adminPaymentData}
                            title="Admin Stripe Payments"
                        />
                    </>}
                </>}
                {edit && <>
                    <div className='mt-3'>
                        <FormField
                            field={{
                                value: commentData?.text,
                                setValue: (value) => setCommentData({ ...commentData, text: value }),
                                label: "Enter any comment",
                                placeholder: "Enter phone",
                                type: "longtext",
                                id: "text",
                            }}
                        />
                        <div className="row mb-3">
                            <label htmlFor={"attachments"} className="col-md-4 col-lg-3 col-form-label">
                                Attachments
                            </label>
                            <div className="col-md-8 col-lg-9">

                                <input
                                    type="file"
                                    id="attachments"
                                    multiple
                                    className="form-control"
                                    onChange={(e) => {
                                        const selectedFiles = Array.from(e.target.files);
                                        setCommentData({
                                            ...commentData,
                                            attachments: selectedFiles,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                            <SubmitButton
                                title={"Add Comments"}
                                loading={loading == "attachment"}
                                onClick={() => {
                                    addAttachment(editData)
                                }}
                                color={"success"}
                                loaderColor={"white"}
                                disabled={
                                    commentData?.text == "" && commentData?.attachments?.length < 1
                                }
                            />
                        </div>
                    </div>

                    <div className='mt-3'>
                        {comments?.map((item, index) => (
                            <div key={index} className="col-md-12 col-12">
                                <div className="card pt-4">
                                    <div className="card-body">
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}><h6 style={{ padding: '0', fontWeight: 'bold' }}>Date Added: </h6><h6 className="mx-2">{item.createdAt?.substring(0, 10)}</h6></Box>
                                        <Box sx={{ display: 'flex' }}><h6 style={{ padding: '0', paddingRight: '10px', fontWeight: 'bold' }} >{`Comment: `}</h6><h6 className="">{item.text}</h6></Box>
                                        <Button onClick={() => downloadFilesAsZip(item.attachments)}>Download attachments</Button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>}
            </div>
        </Screen>
    )
}
